import './App.scss';
import FinanceCalculator from '../FinanceCalculator/FinanceCalculator';
// import MyComponent from '../MyComponent/MyComponent';
// import MyComponent2 from '../MyComponent2/MyComponent2';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <FinanceCalculator />
      </header>
    </div>
  );
}

export default App;
